import {
  ActionType,
  UserListBusinessResponse,
  UserListBusinessPayload,
} from "models/userListBusiness/usersListBusiness";

export const getUserListBusinessAction = (payload: UserListBusinessPayload) => {
  return {
    type: ActionType.USER_LIST_BUSINESS,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.USER_LIST_BUSINESS_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: UserListBusinessResponse) => {
  return {
    type: ActionType.USER_LIST_BUSINESS_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.USER_LIST_BUSINESS_RESET_DATA,
  };
};
